/**
 * https://www.pdftron.com/api/web/Core.AnnotationManager.html#updateCopiedAnnotations__anchor
 */
export default () => {
  window.documentViewer.getAnnotationManager().updateCopiedAnnotations();
};
